export default __webpack_public_path__ + "static/media/dropdownPrint.61383321.svg";